import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LoginInfoDto } from '../models/logininfo/login-info-dto.model';

@Injectable({
  providedIn: 'root',
})
export class LoginInfoService {
  private _http = inject(HttpClient);

  public getLoginInfo(): Promise<LoginInfoDto> {
    return firstValueFrom(this._http.get<LoginInfoDto>(`${environment.apiUrl}/cloud/info`));
  }
}
